import { MOBILE_NAV } from '../actions/Types'


const currentState = window.innerWidth > 700 ? false : true

const MobileNav = (state=currentState, action) => {
    if (action.type === MOBILE_NAV){
        return action.payload
    }
    return state
}

export default MobileNav